import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseProvider } from './base-provider';
import { GlobalsService } from './globals.service';
import { HttpHelperService } from './http-helper.service';

@Injectable({
  providedIn: 'root'
})
export class PhotoSideBySideService extends BaseProvider {

  constructor(
    public globals: GlobalsService,
    private httpHelper: HttpHelperService,
    public http: HttpClient
  ) {
    super();
    this.baseUrl = 'photoSideBySide';
  }

  getPhotoSideBySide(userProcessId: number) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + '/' + userProcessId;

      this.http
        .get(this.url)
        .subscribe(
          (data: any) => {
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }
}

